import type { RadioProps } from "@mui/material";
import { Radio as UnstyledRadio, styled } from "@mui/material";

import { RadioGroup as UnstyledRadioGroup } from "./radio-group";

export const RadioGroup = styled(UnstyledRadioGroup)(({ theme }) => ({
  backgroundColor: theme.palette.grey[200],
  borderRadius: theme.spacing(1.875),
  flexDirection: "row",
  width: "fit-content",

  "& .MuiFormControlLabel-root": {
    margin: 0,
  },

  "& .MuiFormControlLabel-label": {
    display: "none",
  },
})) as typeof UnstyledRadioGroup;

export type RadioColor = NonNullable<Exclude<RadioProps["color"], "default">>;
interface RadioStyleProps {
  color: RadioColor;
}

interface RadioStyleProps extends RadioProps {
  color: RadioColor;
}

export const Radio = styled(UnstyledRadio, {
  shouldForwardProp: (propName: keyof RadioStyleProps) => propName !== "color",
})<RadioStyleProps>(({ color, theme }) => ({
  "&.Mui-checked": {
    backgroundColor: theme.palette[color].main,
    color: theme.palette.common.white,

    "&.Mui-disabled": {
      backgroundColor: theme.palette[color].light,
      color: theme.palette.common.white,
    },
  },
  "&.Mui-disabled": {
    color: theme.palette.action.disabledBackground,
  },
  "&.MuiRadio-sizeSmall": {
    padding: theme.spacing(0.625),
  },
}));
